import "./index.scss"

import "../../pages/newouterpages/index.scss";
import { useEffect, useState } from "react";

const AccountDeletion = () => {
  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const nextUrl = `${window.location.origin}/account-deletion?submitted=1`;

  const handleSubmit = () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("submitted") === "1") {
      setStatus("Thanks! Your request has been received.");
    }

    const mobileMenuBtn = document.querySelector(".y-mobile-menu-btn");
    if (mobileMenuBtn) {
      mobileMenuBtn.addEventListener("click", () => {
        const navLinks = document.querySelector(".y-nav-links");
        navLinks.classList.toggle("y-active");
      });
    }

    return () => {
      const mobileMenuBtn = document.querySelector(".y-mobile-menu-btn");
      if (mobileMenuBtn) {
        mobileMenuBtn.removeEventListener("click", () => {
          const navLinks = document.querySelector(".y-nav-links");
          navLinks.classList.toggle("y-active");
        });
      }
    };
  }, []);

  return (
    <div className="outer-page">
      <header>
        <div className="y-container">
          <nav className="y-navbar">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Birdies%20Logo%20Plain%20%281%29%20%281%29.jpg-HOSyoEEoJ18kWlpTqlUZpdMIUD5Hzx.jpeg"
              alt="Birdies Logo"
              className="y-logo"
            />
            <ul className="y-nav-links">
              <li>
                <a href="/#about">About</a>
              </li>
              <li>
                <a href="/#services">Services</a>
              </li>
              <li>
                <a href="/#food">Food</a>
              </li>
              <li>
                <a href="/#team">Our Team</a>
              </li>
              <li>
                <a href="https://app.birdiesstore.com">Careers</a>
              </li>
              <li>
                <a href="/#fuel-cards">Fuel Cards</a>
              </li>
              <li>
                <a href="/#locations">Locations</a>
              </li>
              <li>
                <a href="/#contact">Contact</a>
              </li>
              <li>
                <a href="/login">Login</a>
              </li>
            </ul>
            <button className="y-mobile-menu-btn">☰</button>
          </nav>
        </div>
      </header>

      <div className="y-container" style={{ paddingTop: 48, paddingBottom: 48, minHeight: "70vh" }}>
        <div style={{ marginBottom: 24 }}>
          <h1 className="section-title">Account Deletion</h1>
          <p style={{ opacity: 0.8 }}>
            Submit the email address associated with your account. Our team will review and process your deletion request in 24hours

          </p>
        </div>

        <form
          className="y-contact-form"
          action="https://formsubmit.co/support@birdiesstore.com"
          method="POST"
          onSubmit={handleSubmit}
        >
          <input type="hidden" name="name" value="Account Deletion Request" />
          <input type="hidden" name="message" value="Please delete my Birdies account and associated data." />
          <input type="hidden" name="_subject" value="Account Deletion Request" />
          <input type="hidden" name="_next" value={nextUrl} />

          <div className="y-form-group">
            <label htmlFor="email">Email</label>
            <input type="email" id="email" name="email" required />
          </div>

          {status && <p>{status}</p>}
          <button type="submit" className="y-btn" disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit Request"}
          </button>
        </form>
      </div>

      <footer>
        <div className="y-container">
          <div className="y-footer-content">
            <div className="y-footer-column">
              <h3>Birdies</h3>
              <p>Your one-stop destination for fuel, food, and service with a smile across 109 locations.</p>
              <img
                src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Birdies%20Logo%20Plain%20%281%29%20%281%29.jpg-HOSyoEEoJ18kWlpTqlUZpdMIUD5Hzx.jpeg"
                alt="Birdies Logo"
                style={{ maxWidth: "150px", marginTop: "15px" }}
              />
            </div>
            <div className="y-footer-column">
              <h3>Quick Links</h3>
              <ul>
                <li>
                  <a href="/#about">About Us</a>
                </li>
                <li>
                  <a href="/#services">Services</a>
                </li>
                <li>
                  <a href="/#food">Food</a>
                </li>
                <li>
                  <a href="/#team">Our Team</a>
                </li>
                <li>
                  <a href="https://app.birdiesstore.com">Careers</a>
                </li>
                <li>
                  <a href="/#locations">Locations</a>
                </li>
                <li>
                  <a href="/privacy-policy">Privacy Policy</a>
                </li>
              </ul>
            </div>
            <div className="y-footer-column">
              <h3>Services</h3>
              <ul>
                <li>
                  <a href="#">Shell Fuel</a>
                </li>
                <li>
                  <a href="#">Sunoco Fuel</a>
                </li>
                <li>
                  <a href="#">Exxon Fuel</a>
                </li>
                <li>
                  <a href="#">Subway</a>
                </li>
                <li>
                  <a href="#">Convenience Store</a>
                </li>
                <li>
                  <a href="#">Fuel Cards</a>
                </li>
              </ul>
            </div>
            <div className="y-footer-column">
              <h3>Contact</h3>
              <ul>
                <li>Email: support@birdiesstore.com</li>
                <li>Phone: 301-982-5400</li>
                <li>7303 Hanover pkwy greenbelt md 20770 STE A</li>
              </ul>
            </div>
          </div>
          <div className="y-copyright">
            <p>&copy; 2025 Birdies. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AccountDeletion;
